export { default } from './MyAccountForm';
